import React from 'react';
import PropTypes from 'prop-types';

/* encapsulates the bootstrap classes and html structure required for error messages in validation */
const ValidationMessage = (props) => {
	return (
		<div className="ValidationMessage">
		{/* kinda hacky, but bootstrap's .invalid-feedback must be a sibling of
		a .form-control.is-invalid but having it inside of an .input-group forces
		it to be inline with the input */}
			<div className='form-control is-invalid d-none'></div>
			<div className='invalid-feedback'>
				{props.message}
			</div>
		</div>
	);
};

ValidationMessage.propTypes = {
	message: PropTypes.string.isRequired
};

export default ValidationMessage;

